import { Button, Grow, Stack, TextField, Typography } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
// import logo from "../../../airplx-logo-transparent-square-no-text.png";
const logo = "/airplx-logo-transparent-square-no-text.png";
import { useTokenMaker } from "../../hooks";

export const LoginWithLink: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { url: tokenMakerURL } = useTokenMaker();
  const [email, setEmail] = React.useState<string>("");
  const [sent, setSent] = React.useState<boolean>(false);
  const onClickSend = async () => {
    await fetch(`${tokenMakerURL}/login/link`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });
    setSent(true);
  };

  return (
    <>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        height="60vh"
        width="100vw"
      >
        <Stack direction="column" width={450}>
          <Grow in={!sent}>
            <Stack direction="column" spacing={1} alignItems="center">
              <Typography variant="h6">{t("login.magicLinkPage.title")}</Typography>
              <Typography variant="body2" color="textSecondary">
                {t("login.magicLinkPage.description")}
              </Typography>
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                width="100%"
              >
                <TextField
                  size="small"
                  fullWidth
                  label={t("login.magicLinkPage.emailLabel")}
                  variant="outlined"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
                <Button
                  disabled={
                    // disabled if email does not match @airplx.com or @amway.com
                    !email.match(/@(gmail|hotmail|airplx|amway)\.com$/) ||
                    email.length === 0
                  }
                  variant="contained"
                  color="primary"
                  onClick={onClickSend}
                >
                  {t("login.magicLinkPage.sendButton")}
                </Button>
              </Stack>
            </Stack>
          </Grow>
          <Grow in={sent}>
            <Stack direction="column" spacing={1} alignItems="center">
              <Typography variant="h6">{t("login.magicLinkPage.successTitle")}</Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                align="center"
                dangerouslySetInnerHTML={{
                  __html: t("login.magicLinkPage.successMessage", { email })
                }}
              />
            </Stack>
          </Grow>
        </Stack>
      </Stack>
      <img
        src={logo}
        style={{ position: "fixed", bottom: 15, right: 15, width: 50 }}
      />
    </>
  );
};
